import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { sec } from "../../../security";

const apiServerUrl = process.env.REACT_APP_HAISTACK_API_URL;

export const employerApi = createApi({
  reducerPath: "employer",
  tagTypes: ["Employers"],
  baseQuery: fetchBaseQuery({
    baseUrl: apiServerUrl,
    prepareHeaders: async (headers) => {
      const token = await sec.getAccessTokenSilently()();

      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }

      return headers;
    }
  }),
  endpoints: (builder) => ({
    getEmployers: builder.query({
      query: (query: string) => {
        const queryString = query ? `?query=${query}` : "";
        return `api/v2/employers${queryString}`;
      },
      transformResponse: (response: any) => {
        return response.employers;
      }
    })
  })
});

export const { useGetEmployersQuery } = employerApi;
